var boundary_box = jinjaVars.boundary_box;

var mapBoxStylePath = 'https://m.24timezones.com/styles/osm-bright-' + jinjaVars.lang + '/style.json';
var mapBoxHybridStylePath = 'https://m.24timezones.com/styles/hybrid-' + jinjaVars.lang + '/style.json';
var mapBackgroundLang = jinjaVars.lang;

var CUSTOM_LANGS = ['da'];

if (CUSTOM_LANGS.includes(jinjaVars.lang)) {
    mapBoxStylePath = '/map/osm-bright-' + jinjaVars.lang + '/style.json';
    mapBoxHybridStylePath = '/map/hybrid-' + jinjaVars.lang + '/style.json';
    mapBackgroundLang = 'en';
}

function renderOpenStreetMap() {
    mapboxgl.accessToken = jinjaVars.mapbox_token;
    var mapbox_satellite_layer = jinjaVars.mapbox_satellite_layer;
    var map;

    var sw = new mapboxgl.LngLat(parseFloat(boundary_box['west']), parseFloat(boundary_box['south']));
    var ne = new mapboxgl.LngLat(parseFloat(boundary_box['east']), parseFloat(boundary_box['north']));
    var b_box = new mapboxgl.LngLatBounds(sw, ne);

    map = new mapboxgl.Map({
        container: 'map',
        style: mapBoxStylePath,
        zoom: 7,
        center: b_box.getCenter(),
        attributionControl: false,
        preserveDrawingBuffer: true
    });

    map.addControl(new MapBoxGoogleCustomSearch({
        resultsUrl: '/' +jinjaVars.lang + '/admin-divisions/gcse-search/' + jinjaVars.adm1_name_url
    }), 'top-left');

    map.addControl(
        new MapBoxToPdfControl(
            jinjaVars.adm1_name,
            jinjaVars.save_to_pdf,
            jinjaVars.download_pdf
        ), 'top-left');

    map.addControl(new MapBoxDirectionsControl(
        jinjaVars.adm1_name,
        jinjaVars.directions
    ), 'top-left');

    map.fitBounds([
        [parseFloat(boundary_box['west']), parseFloat(boundary_box['south'])],
        [parseFloat(boundary_box['east']), parseFloat(boundary_box['north'])]
    ]);
    map.addControl(new mapboxgl.NavigationControl({showCompass: false}));

    var map_styles = [
        {
            id: 'street',
            title: jinjaVars.map,
            uri: mapBoxStylePath
        },
        {
            id: 'satellite',
            title: jinjaVars.satellite,
            uri: mapBoxHybridStylePath
        }
    ];
    var switcher_control = new MapBoxStyleSwitcherControl(map_styles, 'street');
    map.addControl(switcher_control);

    function addBoundaryLayer()
    {
        map.addSource('state_boundary', {
            type: 'geojson',
            data: '/js/data/' + jinjaVars.country_code_lower + '_divisions/' + jinjaVars.adm1_code + '.geojson'
        });
        map.addLayer({
            id: 'state_boundary',
            type: 'fill',
            source: 'state_boundary',
            paint: {
                'fill-color': '#3276b1',
                'fill-opacity': 0.06
            }
        });
    }

    function waitToLoadBoundaries() {
        if (!map.isStyleLoaded()) {
            setTimeout(waitToLoadBoundaries, 200);
        } else {
            addBoundaryLayer();
        }
    }

    map.on('load', function() {
        addBoundaryLayer();

        map.on('styledataloading', function(e) {
            waitToLoadBoundaries();
        });
    });
}
if(mapboxgl.supported()) {
    renderOpenStreetMap();
} else {
    var map_center = {};
    map_center.lat = (boundary_box['south'] + boundary_box['north']) / 2;
    map_center.lon = (boundary_box['east'] + boundary_box['west']) / 2;
    $('#map').css({
        'background-image': 'url(https://m.24timezones.com/styles/osm-bright-' + mapBackgroundLang + '/static/' + map_center.lon + ',' + map_center.lat + ',6/800x600.png)',
        'background-repeat': 'no-repeat'
    }).append($('#gmap-search-box').show());
    $('#pac-input').replaceWith($('<gcse:searchbox-only>').attr({
        "adchannel": "2928985636", "lr": 'lang_' + jinjaVars.lang,
        "webSearchQueryAddition":  jinjaVars.adm1_name
    }));
    (function() {
        var cx = 'partner-pub-6183744382086490:4052689605';
        var gcse = document.createElement('script');
        gcse.type = 'text/javascript';
        gcse.async = true;
        gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gcse, s);
    })();
}

function createPoly() {
    return new google.maps.Polygon({
        paths: divisionBorders,
        strokeColor: '#3276b1',
        strokeOpacity: 0.40,
        strokeWeight: 1,
        fillColor: '#3276b1',
        fillOpacity: 0.06
    });
}

function load_polygons(map) {
    var polygon = createPoly();
    polygon.setMap(map);
}

function getBoundsZoomLevel(bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

function initialize() {
    var boundary_box = jinjaVars.boundary_box;
    var bounds_obj = new google.maps.LatLngBounds(
        {'lat': parseFloat(boundary_box['south']), 'lng': parseFloat(boundary_box['west'])},
        {'lat': parseFloat(boundary_box['north']), 'lng': parseFloat(boundary_box['east'])}
    );
    var $map_canvas = $('#map');
    var mapOptions = {
        center: bounds_obj.getCenter(),
        gestureHandling: 'greedy',
        zoom: getBoundsZoomLevel(bounds_obj, {height: $map_canvas.height(), width: $map_canvas.width()}),
        mapTypeControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER
        }
    };
    var map = new google.maps.Map($map_canvas[0], mapOptions);
    // map.fitBounds(bounds_obj);

    var search_input = document.getElementById('pac-input');
    new InMapSearchInput(map, search_input, document.getElementById('info-window-content'));
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(search_input);

    var centerControlDiv = document.createElement('div');
    new GMapToPdf2Control(
        centerControlDiv, map, jinjaVars.adm1_name,
        jinjaVars.save_to_pdf, jinjaVars.download_pdf
    );
    centerControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_TOP].push(centerControlDiv);

    var directionsControlDiv = document.createElement('div');
    new DirectionsRedirectControl(directionsControlDiv, map,
        jinjaVars.adm1_name + ', ' + jinjaVars.country_code,
        jinjaVars.directions
    );
    directionsControlDiv.index = 2;
    map.controls[google.maps.ControlPosition.LEFT_TOP].push(directionsControlDiv);

    if (['CA', 'IN'].includes(jinjaVars.country_code)) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '/js/data/' + jinjaVars.country_code_lower + '_divisions/' + jinjaVars.adm1_code + '.js';
        script.async = true;

        if (script.readyState) {  //IE
            script.onreadystatechange = function () {
                load_polygons(map);
            };
        } else {  //Others
            script.onload = function () {
                load_polygons(map);
            };
        }
        document.getElementsByTagName('head')[0].appendChild(script);
    } else {
        map.data.loadGeoJson('/js/data/' + jinjaVars.country_code_lower + '_divisions/' + jinjaVars.adm1_code + '.geojson');
        map.data.setStyle({
            strokeColor: '#3276b1',
            strokeOpacity: 0.40,
            strokeWeight: 1,
            fillColor: '#3276b1',
            fillOpacity: 0.06
        });
    }
}
